import { Context, createContext, ReactNode, useContext } from "react";

const BridgeContext = createContext<Context<unknown> | null>(null);

function BridgeProvider<T>({
  children,
  context,
}: {
  children: ReactNode;
  context: Context<T>;
}) {
  return (
    <BridgeContext.Provider value={context as Context<unknown>}>
      {children}
    </BridgeContext.Provider>
  );
}

function useBridge<T>() {
  const context = useContext(BridgeContext) as Context<T> | null;
  if (!context) throw new Error("Illegal Usage of Context");
  return useContext(context);
}

export {useBridge, BridgeProvider};